"use client";
import Image from "next/image";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

import TradeHeadings from "@/components/app/trade/trade-header/trade-headings";
import TradeOverview from "@/components/app/trade/trade-header/trade-overview";
import { APP_ROUTES } from "@/utils/constants";

import { TradeCoinDialogDynamic } from "../coin-dialog";
import { TotalTokens } from "../total-tokens";

interface TradeLayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: Readonly<TradeLayoutProps>) {
  const pathname = usePathname();

  return (
    <div className="relative h-full min-h-safe-screen">
      <TradeCoinDialogDynamic />

      {pathname === APP_ROUTES.tradeTrending && (
        <div
          className="
            h-[100px] overflow-hidden
            sm:h-[200px]
          "
          style={{
            WebkitMaskImage:
              "linear-gradient(180deg, #000000FF 40%, #00000000 100%)",
          }}
        >
          <Image
            src="/assets/empty-37.jpg"
            alt="Trade Overview"
            width={1100}
            height={0}
          />
        </div>
      )}

      <div
        className="
          flex w-full flex-col items-start justify-between rounded-none border-b
          border-border px-4 py-2
          md:flex-row
          lg:px-6
        "
      >
        <TradeHeadings />
        <TradeOverview />
      </div>
      <TotalTokens />
      {children}
    </div>
  );
}
